import { TextField, Typography } from '@mui/material';
import { Icon, InputWithIcon } from '@livable/saas-react-components';
import PropTypes from 'prop-types';
import React from 'react';
import TenantsListSelector from 'src/components/property/TenantsListSelector';
import useStyles from './styles';
export default function UpdatesTab(props) {
  const classes = useStyles();
  const _props$tenantsList = props.tenantsList,
    tenantsList = _props$tenantsList === void 0 ? undefined : _props$tenantsList,
    _props$buildingsList = props.buildingsList,
    buildingsList = _props$buildingsList === void 0 ? undefined : _props$buildingsList;
  return /*#__PURE__*/React.createElement(React.Fragment, null, buildingsList && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Select who to apply new fees"), tenantsList && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Select what units to update"), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "input-with-icon",
    label: "Search the list for residents",
    variant: "outlined",
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, buildingsList && /*#__PURE__*/React.createElement(React.Fragment, null, buildingsList.map(building => /*#__PURE__*/React.createElement(TenantsListSelector, {
    key: building.address,
    type: "building",
    title: building.address,
    list: building.tenants
  }))), tenantsList && /*#__PURE__*/React.createElement(TenantsListSelector, {
    title: "Select all residents in the building",
    list: tenantsList
  })));
}
UpdatesTab.propTypes = {
  tenantsList: PropTypes.arrayOf(PropTypes.string),
  buildingsList: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
    tenants: PropTypes.arrayOf(PropTypes.string)
  }))
};